import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { LocalStorageService } from "./local-storage.service";

const defaultUser = null;

@Injectable()
export class UserContextService {
    public user$ = new BehaviorSubject(defaultUser);

    constructor(
        private localStorageService: LocalStorageService) {            
        let data = this.localStorageService.getItem("currentUser");
        if (data != null) {
            this.user$.next(data);
        }
    }

    public setUser(user: any) {        
        this.localStorageService.setItem("currentUser", user);
        this.user$.next(user);
    }

    public logout() {
        this.localStorageService.removeItem("token");
        this.localStorageService.removeItem("currentUser");
        this.user$.next(defaultUser);
    }

}